/*
 *  Bootstrap Nice Select Romanian (Romania) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['ro-RO'] = localisation.locales['ro'] = {
    formatSearch() {
        return "In cautarea...";
    },
    formatHelpForTagging() {
        return "Pentru a crea propriile etichete, focalizați câmpul de introducere și apoi apăsați 'Enter' sau ',' sau 'bara de spațiu' pentru a-l adăuga la listă";
    }
}

export default localisation;